import React, { useState } from 'react';
import { login } from './api';
import { colors, spacing, radius, fontSizes, presets } from './theme';
import bgImageAdmin from './assets/Aetherisbackground4.webp';

const AdminLoginForm = ({ onLoggedIn, onBack }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const result = await login({ username, password });
      onLoggedIn(result);
    } catch (err) {
      setError('Invalid credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh', 
      backgroundColor: colors.bgPrimary,
      backgroundImage: `url(${bgImageAdmin})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      padding: spacing.xl,
      position: 'relative'
    }}>
      {/* Heavy Darkening Overlay for Administrative Atmosphere */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(5, 5, 8, 0.65)',
        zIndex: 0
      }} />

      {/* High-Clearance System Override Card */}
      <div className="animate-fade-in" style={{ 
        ...presets.card,
        ...presets.chromeGlass,
        padding: '40px', 
        width: '100%',
        maxWidth: '400px',
        boxShadow: `0 24px 64px rgba(0, 0, 0, 0.95), 0 0 1px ${colors.accentAdminGlow}`,
        borderColor: colors.accentAdminGlow,
        position: 'relative',
        zIndex: 10
      }}>
        <h1 style={{ 
          margin: `0 0 ${spacing.xs} 0`, 
          fontSize: '24px', 
          fontWeight: '700', 
          letterSpacing: '-0.5px',
          color: colors.accentAdmin,
          textAlign: 'center'
        }}>
          Admin Access
        </h1>
        <p style={{
          textAlign: 'center',
          fontSize: fontSizes.xs,
          color: colors.textMuted,
          textTransform: 'uppercase',
          letterSpacing: '0.12em',
          marginBottom: spacing.xl
        }}>
          Secure Terminal Override
        </p>
        
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: spacing.lg }}>
            <label style={{ 
              display: 'block', 
              marginBottom: spacing.sm, 
              color: colors.textSecondary, 
              fontSize: fontSizes.sm,
              fontWeight: '500' 
            }}>Username</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{ 
                width: '100%', 
                padding: spacing.md, 
                background: 'rgba(5, 5, 8, 0.6)', 
                border: `1px solid ${colors.borderDefault}`, 
                borderRadius: radius.sm,
                color: colors.textPrimary,
                fontSize: fontSizes.md,
                outline: 'none',
                transition: 'border-color 0.2s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = colors.accentAdmin}
              onBlur={(e) => e.target.style.borderColor = colors.borderDefault}
            />
          </div>
          <div style={{ marginBottom: spacing.xl }}>
            <label style={{ 
              display: 'block', 
              marginBottom: spacing.sm, 
              color: colors.textSecondary, 
              fontSize: fontSizes.sm,
              fontWeight: '500' 
            }}>Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ 
                width: '100%', 
                padding: spacing.md, 
                background: 'rgba(5, 5, 8, 0.6)', 
                border: `1px solid ${colors.borderDefault}`, 
                borderRadius: radius.sm,
                color: colors.textPrimary,
                fontSize: fontSizes.md,
                outline: 'none',
                transition: 'border-color 0.2s ease'
              }}
              onFocus={(e) => e.target.style.borderColor = colors.accentAdmin}
              onBlur={(e) => e.target.style.borderColor = colors.borderDefault}
            />
          </div>
          
          {error && (
            <p style={{ 
              color: colors.error, 
              fontSize: fontSizes.sm, 
              background: 'rgba(255, 68, 102, 0.08)', 
              padding: spacing.sm, 
              borderRadius: radius.sm, 
              border: `1px solid rgba(255, 68, 102, 0.15)`,
              marginBottom: spacing.lg 
            }}>{error}</p>
          )}
          
          <button 
            type="submit" 
            disabled={loading} 
            style={{ 
              background: `linear-gradient(135deg, ${colors.accentAdmin} 0%, #cc6a00 100%)`,
              border: `1px solid ${colors.accentAdmin}`,
              borderRadius: radius.sm,
              color: colors.textPrimary,
              fontWeight: '600',
              letterSpacing: '0.5px',
              cursor: 'pointer',
              boxShadow: `0 0 12px ${colors.accentAdminGlow}`,
              transition: 'all 0.25s ease',
              width: '100%', 
              padding: spacing.md,
              fontSize: fontSizes.md
            }}
            onMouseEnter={(e) => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={(e) => e.currentTarget.style.opacity = '1'}
          >
            {loading ? 'Authenticating...' : 'Log In'}
          </button>
        </form>
        
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: spacing.xl }}>
          <button
            type="button"
            onClick={onBack}
            style={{ 
              background: 'none', 
              border: 'none', 
              color: colors.textMuted, 
              fontSize: fontSizes.sm,
              cursor: 'pointer', 
              padding: 0,
              transition: 'color 0.2s ease'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = colors.textSecondary}
            onMouseLeave={(e) => e.currentTarget.style.color = colors.textMuted}
          >
            ← Back to User Login
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdminLoginForm;
